import React from 'react';
import { Table, Typography } from 'antd';


const { Title } = Typography;


const columns = [
{
title: 'Name',
key: 'name',
render: (_, rec) => `${rec.first_name || ''} ${rec.last_name || ''}`,
},
{ title: 'Email', dataIndex: 'email', key: 'email' },
{ title: 'City', dataIndex: 'city', key: 'city' },
{
title: 'Submitted',
dataIndex: 'created_at',
key: 'created_at',
render: (t) => (t ? t.replace('T', ' ').split('.')[0] : '-'),
},
];


export default function PendingTable({ data = [], loading = false, title = 'Recent Pending Registrations' }) {
return (
<div>
<Title level={5} style={{ marginBottom: 12 }}>{title}</Title>
<Table rowKey="id" columns={columns} dataSource={data} pagination={false} loading={loading} locale={{ emptyText: 'No recent pending registrations' }} scroll={{ x: true }} />
</div>
);
}